import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { Router } from '@angular/router';
import {CustomHttp} from '../../shared/custom.http';


@Injectable()
export class InfohashService {

    private infohashURL = '/infohash';  // URL to web api


    constructor(private router: Router, private http: CustomHttp) {
    }

    getInfohash() {
        let url;
        url = `${this.infohashURL}`;
        return this.http.get(url, { body: '' });
    }

    updateMapping(redirectTo: string, request: any) {
        const url = `${this.infohashURL}?redirectTo=` + redirectTo;
        return this.http.put(url, JSON.stringify(request));
    }



}



// WEBPACK FOOTER //
// ./src/app/catalogue/infohash/infohash.service.ts